import React, {PropsWithChildren} from 'react';
import {useAsync} from "react-async-hook";
import roomLogo from "../../assets/images/room_logo.png";
import {config} from "../../libs/config/config";

export const DefaultLayout: React.FC = ({children,}: PropsWithChildren<any>) => {
  useAsync(
    async () => {
      document.title = config.app.room.name;
    },
    []);

  return (
    <>
      <main>
        <div className="flex min-h-screen">
          <div className="w-full">
            <div className="flex flex-col justify-center items-center min-w-full min-h-screen p-16">
              <img src={roomLogo} className="w-80" alt="icon" />
            </div>
          </div>

          <div className="w-full">
            {children}
          </div>
        </div>
      </main>
    </>
  );
};